(function () {
  'use strict'

  class ProductShowcaseTabs {
    constructor (container) {
      this.container = container
      this.tabs = Array.from(container.querySelectorAll('.product-showcase-tabs__tab'))
      this.panels = Array.from(container.querySelectorAll('.product-showcase-tabs__tab-content'))
      this.shopMorePanels = Array.from(container.querySelectorAll('[data-tab-mobile-shop-more]'))
      this.currentTabIndex = 0

      this.init()
    }

    init () {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.switchTab(index))
      })

      this.render()
    }

    switchTab (tabIndex) {
      if (tabIndex === this.currentTabIndex) return
      this.currentTabIndex = tabIndex
      this.render()
    }

    render () {
      this.renderTabs()
      this.renderShopMore()
    }

    renderTabs () {
      this.tabs.forEach((tab, index) => {
        const active = index === this.currentTabIndex
        tab.classList.toggle('product-showcase-tabs__tab--active', active)
        tab.setAttribute('aria-selected', active ? 'true' : 'false')
      })

      this.panels.forEach((panel, index) => {
        panel.classList.toggle('product-showcase-tabs__tab-content--active', index === this.currentTabIndex)
      })
    }

    renderShopMore () {
      const activeTabId = this.tabs[this.currentTabIndex]?.dataset.tab
      this.shopMorePanels.forEach((panel) => {
        panel.classList.toggle(
          'product-showcase-tabs__shop-more--active',
          panel.dataset.tabMobileShopMore === activeTabId
        )
      })
    }
  }

  function initProductShowcaseTabs () {
    document.querySelectorAll('.product-showcase-tabs').forEach((container) => {
      if (container.dataset.productShowcaseTabsReady === 'true') return
      container.dataset.productShowcaseTabsReady = 'true'
      new ProductShowcaseTabs(container)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductShowcaseTabs)
  } else {
    initProductShowcaseTabs()
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initProductShowcaseTabs)
  }
})()
